import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IProficiencyReport } from "app/models/core/reports/proficiencyReport";
import { SharedService } from "app/services/core/shared.service";
import { ReportsService } from "app/services/reports/reports.service";


@Component({
  selector: 'app-proficiencyReports',
  templateUrl: './proficiencyReports.component.html',
  styleUrls: ['./proficiencyReports.component.scss'],
})

export class ProficiencyReportsComponent implements OnInit {

  list: IProficiencyReport[] = [];

  reportMode = 'none';
  dateNow = '';
  year0 = 0;
  year1 = 0;

  displayedColumns: string[] = [ 'labName', 'accreditation', 'ptTest',
    'yr0_1', 'yr0_2', 'yr0_3', 'yr1_1', 'yr1_2', 'yr1_3'
  ];
  dataSource = new MatTableDataSource<IProficiencyReport>(this.list);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public reportsService: ReportsService,
    public sharedService: SharedService,
    private datePipe: DatePipe) { };

  ngOnInit(): void {
    this.dateNow = this.datePipe.transform(new Date(), 'EEEE, MMMM dd, yyyy')
    this.year1 = (new Date()).getFullYear();
    this.year0 = this.year1 - 1;
    this.reportsService.currentTab = 0;
  }

  proficiencyReport() {
    this.reportsService.failedProficiencyReport('6').subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
        this.reportMode = 'list';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  csv(mode:string){
    this.sharedService.exportToCsv('PtErrorReport.csv', this.list);
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

}
